var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWebDev(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 46,
    viewBox: "0 0 50 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 49.2865,
    height: 46,
    rx: 9.57895,
    fill: "#0825B4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.4433 16C13.4433 14.4556 14.6989 13.2 16.2433 13.2H33.0433C34.5877 13.2 35.8433 14.4556 35.8433 16V27.2H33.0433V16H16.2433V27.2H13.4433V16ZM10.6433 29.44C10.6433 28.9762 11.0196 28.5999 11.4833 28.5999H37.8033C38.2671 28.5999 38.6433 28.9762 38.6433 29.44C38.6433 31.295 37.1383 32.7999 35.2833 32.7999H14.0033C12.1483 32.7999 10.6433 31.295 10.6433 29.44ZM22.9371 20.9437L21.5808 22.3L22.9371 23.6562C23.3483 24.0675 23.3483 24.7325 22.9371 25.1393C22.5258 25.5462 21.8608 25.5506 21.4539 25.1393L19.3539 23.0393C18.9427 22.6281 18.9427 21.9631 19.3539 21.5562L21.4539 19.4562C21.8652 19.045 22.5302 19.045 22.9371 19.4562C23.3439 19.8675 23.3483 20.5325 22.9371 20.9393V20.9437ZM27.8371 19.4562L29.9371 21.5562C30.3483 21.9675 30.3483 22.6325 29.9371 23.0393L27.8371 25.1393C27.4258 25.5506 26.7608 25.5506 26.3539 25.1393C25.9471 24.7281 25.9427 24.0631 26.3539 23.6562L27.7102 22.3L26.3539 20.9437C25.9427 20.5325 25.9427 19.8675 26.3539 19.4606C26.7652 19.0537 27.4302 19.0493 27.8371 19.4606V19.4562Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebDev);
export default __webpack_public_path__ + "static/media/web-dev.4bc20595e8469fc2652c958b5624a1f9.svg";
export { ForwardRef as ReactComponent };